module.exports = __webpack_public_path__ + "img/templates-used.d185dd94.svg";